/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface DiscountBase
 */
export interface DiscountBaseOptional {
  /**
   *
   * @type {string}
   * @memberof DiscountBase
   */
  discountName?: string;
}

export interface DiscountBase extends DiscountBaseOptional {
  /**
   *
   * @type {string}
   * @memberof DiscountBase
   */
  discountName: string;
}

export interface DiscountBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof DiscountBase
   */
  discountName?: string;
  discountNameIsSet: boolean;
}

transformDatesMap.set("DiscountBase", function (model: DiscountBase) {});

export type DiscountBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  discountName: PropertyMeta<MetaTypeBase<string>>;
}>;

export var DiscountBaseMeta: DiscountBaseMetaI = {} as DiscountBaseMetaI;
DiscountBaseMeta = typeMeta("DiscountBase", {
  discountName: propertyMeta(
    "discountName",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = DiscountBaseMeta;

registerMeta(() => {});

export class DiscountBaseTracked implements DiscountBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  discountName__I?: string = undefined;
  discountNameIsSet: boolean = false;
  set discountName(v: undefined | string) {
    if (v !== undefined) {
      this.discountName__I = v;
      this.discountNameIsSet = true;
    } else {
      this.discountName__I = v || undefined;
      this.discountNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get discountName() {
    return this.discountName__I;
  }
  constructor(config?: DiscountBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: DiscountBaseOptional,
    options?: AssignOptions,
  ): DiscountBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.discountName &&
      this.discountNameApplyFilter(optionsRequired.filter)
    ) {
      this.discountName = config.discountName;
      if (optionsRequired.unassign) this.discountNameIsSet = false;
      else this.discountNameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DiscountBaseTrackedI {
    const cloned = {} as DiscountBaseTrackedI;
    if (
      this.discountNameIsSetDeep() &&
      this.discountNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountNameIsSet = true;
      cloned.discountName = this.discountName;
    } else {
      //cloned.discountNameIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DiscountBaseTrackedI {
    if (!this.discountNameApplyFilter(filter)) this.discountNameIsSet = false;

    return this;
  }
  discountNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DiscountBaseMeta.discountName,
      DiscountBaseMeta,
      this.discountName,
      this,
    );
  }
  discountNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountNameIsSet && this.discountNameApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.discountNameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
